import { IppicaScommesseEsitoAntepostTipoBox } from '../ippicaScommesseEsitoTipoBox/IppicaScommesseEsitoTipoBox';
import { KeyManagerIppica } from 'features/ippica/utils/keyManagerIppica';
import { ScommesseTableStatsFrame } from 'components/scommesseTable/scommesseTableStatsFrame';
import { Stato } from 'features/ippica/types';
import { capitalize } from 'utility/functions';
import { isEqualStatoScommessaByKey } from 'features/ippica/functions';
import { selectKeyListQuoteAntepost } from 'features/ippica/selectors';
import styles from './IppicaScommesseTableAntepostRow.module.scss';
import { useCreateStatsPathByNumCavallo } from '../hook';
import { useGetCavallo } from 'features/ippica/hooks';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useMemo } from 'react';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseTableAntepostRowProps = {
  indexCavallo: number;
  keyCavallo: string;
};

export const IppicaScommesseTableAntepostRow = ({ keyCavallo, indexCavallo }: IppicaScommesseTableAntepostRowProps) => {
  const labelVincente = useGetLabelByKey('vincente');
  const { numeroCavallo, nomeCavallo, codiceStatoAvvenimento } = useGetCavallo(keyCavallo);
  const stats = useCreateStatsPathByNumCavallo(numeroCavallo);
  const quoteAntepostKeyList = useTypedSelector(selectKeyListQuoteAntepost(keyCavallo));
  const isNotClickable = useMemo(
    () => isEqualStatoScommessaByKey(codiceStatoAvvenimento, Stato.Chiusa),
    [codiceStatoAvvenimento]
  );
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <span className={styles.span}>{numeroCavallo}</span>
        <p className={styles.paragrpah}>{capitalize(nomeCavallo)}</p>
        <div className={styles.btnWrapper}>
          {stats && <ScommesseTableStatsFrame statsUrl={stats} className={styles.statsWrapper} title={'Statistiche'} />}
        </div>
      </div>

      <div className={styles.quoteWrapper}>
        {quoteAntepostKeyList.map((keyQuota) => {
          const { avvenimentoKey, codiceTipoScommessa } = new KeyManagerIppica(keyCavallo);
          return (
            <IppicaScommesseEsitoAntepostTipoBox
              key={keyQuota}
              scommessaKey={`${avvenimentoKey}_102_${codiceTipoScommessa}`}
              keyQuota={keyQuota}
              keyCavallo={keyCavallo}
              label={labelVincente}
              containerClassName={isNotClickable ? styles.isNotClickable : ''}
            />
          );
        })}
      </div>
    </div>
  );
};
